import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 0px 4px 10px',
    background: '#EEF2F7',
    border: '1px solid #D9E2EC',
    borderRadius: 30,
    marginRight: 6,
  },
  filterName: {
    margin: '0px 5px 0px 0px',
    fontFamily: 'Poppins',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 500,
    color: '#4B5563',
  },
}));
